// extracted by mini-css-extract-plugin
export default {"arrow":"GroupMembersPanel_arrow__tNBam","arrowOpen":"GroupMembersPanel_arrowOpen__fOWi1"};